import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { IchQueryFilterConfig, IIchResponse } from 'fa-kt.types';

import { IchService } from '../service';

@Component({
  selector: 'fa-kt-ich-filter',
  templateUrl: './ich-filter.component.html',
  styleUrls: ['./ich-filter.component.css'],
})
export class IchFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public IchFilterConfig: IFilterConfig<IIchResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public ich: IchService,
  ) {
    this.IchFilterConfig = IchQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
    /* << update mapper    */
    /*    update mapper >> */
  }

  ngOnInit() {
    this.subscriptions.push();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.IchFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.IchFilterConfig[index].selections = shapes;
  }
}
